import { render } from "./App.vue?vue&type=template&id=b80a8000"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b80a8000&lang=css"

import exportComponent from "C:\\Data\\DevEnv\\projects\\Yifat\\pwa\\hello-world4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__